import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function AddMiniGame5Modal({ isOpen, toggle, onQuestionAdded }) {
  const [question, setQuestion] = useState("");
  const [mcq, setMCQ] = useState([]);
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setQuestion("");
    setMCQ([]);
    setAnswer("");
  };

  const handleSubmit = async () => {
    if (!question.trim() || mcq.length === 0 || !answer.trim()) {
      Swal.fire("Error", "Please fill all fields.", "error");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 5",
        question: question.trim(),
        mcq,
        answer: answer.trim(),
        levelRef: 1,
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add MiniGame 5 Question</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Question</Label>
          <Input
            type="textarea"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            rows={2}
            placeholder="Enter question"
          />
        </FormGroup>
        <FormGroup>
          <Label>MCQ Options (one per line)</Label>
          <Input
            type="textarea"
            value={mcq.join("\n")}
            onChange={(e) => setMCQ(e.target.value.split("\n"))}
            rows={4}
            placeholder="Enter options, one per line"
          />
        </FormGroup>
        <FormGroup>
          <Label>Answer</Label>
          <Input
            type="text"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            placeholder="Enter answer"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
